
export default function CaseStudiesSection() {
  const caseStudies = [
    {
      company: '製造業A社',
      industry: '製造業',
      challenge: '生産効率の低下とコスト増加',
      solution: '業務プロセス改善とデジタル化推進',
      result: '生産効率30%向上、コスト20%削減',
      image: 'https://public.readdy.ai/ai/img_res/f718f4cb5895644a783ac7d504bc57ce.jpg'
    },
    {
      company: 'IT企業B社',
      industry: 'IT・テクノロジー',
      challenge: '市場競争激化による売上減少',
      solution: '新規事業戦略立案と市場開拓支援',
      result: '新規事業で売上50%増加',
      image: 'https://readdy.ai/api/search-image?query=Modern%20IT%20company%20office%20with%20developers%20working%20on%20computers%2C%20multiple%20monitors%20displaying%20code%20and%20analytics%2C%20innovative%20technology%20workspace%2C%20representing%20successful%20digital%20transformation%20and%20business%20growth&width=400&height=300&seq=case-it&orientation=landscape'
    },
    {
      company: '小売業C社',
      industry: '小売・流通',
      challenge: 'オンライン化の遅れと顧客離れ',
      solution: 'DX戦略とオムニチャネル構築',
      result: 'オンライン売上200%増加',
      image: 'https://readdy.ai/api/search-image?query=Modern%20retail%20store%20with%20digital%20integration%2C%20customers%20using%20mobile%20apps%20for%20shopping%2C%20omnichannel%20experience%20with%20online%20and%20offline%20integration%2C%20successful%20digital%20transformation%20in%20retail%20industry&width=400&height=300&seq=case-retail&orientation=landscape'
    }
  ];

  return (
    <section id="case-studies" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            成功事例
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            様々な業界のお客様の課題解決と成長を支援した実績をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <img
                src={study.image}
                alt={study.company}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-gray-900">{study.company}</h3>
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                    {study.industry}
                  </span>
                </div>
                
                <div className="space-y-3">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">課題</h4>
                    <p className="text-sm text-gray-600">{study.challenge}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">ソリューション</h4>
                    <p className="text-sm text-gray-600">{study.solution}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">成果</h4>
                    <p className="text-sm font-medium text-green-600">{study.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-file-text-line mr-2"></i>
            詳細な事例資料をダウンロード
          </button>
        </div>
      </div>
    </section>
  );
}
